import 'toastr/build/toastr.css';
import * as toastr from 'toastr';
import * as log from 'loglevel';

const FADE_IN_DURATION = 300,
    DISPLAY_DURATION = 5000,
    FADE_OUT_DURATION = 1000,
    MAX_AMOUNT_OF_MESSAGES = 5;

toastr.options.closeButton = true;
toastr.options.debug = false;
toastr.options.newestOnTop = false;
toastr.options.progressBar = false;
toastr.options.positionClass = 'toast-bottom-center';
toastr.options.preventDuplicates = false;
toastr.options.onclick = null;
toastr.options.showDuration = FADE_IN_DURATION;
toastr.options.timeOut = DISPLAY_DURATION;
toastr.options.hideDuration = FADE_OUT_DURATION;
toastr.options.extendedTimeOut = 1000;
toastr.options.showEasing = 'swing';
toastr.options.hideEasing = 'linear';
toastr.options.showMethod = 'fadeIn';
toastr.options.hideMethod = 'fadeOut';

let toastCount: number = 0,
    toastLock: boolean = false,
    firstToastTime: number;

const PRESENTATION_TIME = FADE_IN_DURATION + DISPLAY_DURATION + FADE_OUT_DURATION + 100,
    MUTE_DURATION = 20000; //event-polling usually happens every 30sec so mute for a shorter period

toastr.subscribe((toastResponse: ToastrResponse) => {
    if (toastResponse.state === 'visible') {
        toastCount++;
    }

    if (toastLock) {
        return;
    }

    if (toastCount === 1) {
        firstToastTime = Date.now();
    }

    if (toastCount + 1 > MAX_AMOUNT_OF_MESSAGES && Date.now() - firstToastTime < PRESENTATION_TIME) {
        //prevent spam of notifications

        toastLock = true;
        log.debug(`Muting Toastr notifications for ${MUTE_DURATION} milliseconds.`);
        toast.admin('...amongst many other events have taken place.');

        setTimeout(() => {
            log.debug(`Un-muting Toastr notifications, resetting count to 0 which was previously ${toastCount}.`);
            toastLock = false;
            toastCount = 0;
        }, MUTE_DURATION);
    } else if (toastCount + 1 <= MAX_AMOUNT_OF_MESSAGES && Date.now() - firstToastTime >= PRESENTATION_TIME) {
        toastCount = 0; //not enough notifications in a short timespan to be considered spam so reset
    }
});

export const toast = {
    success: (message: string, title?: string) => {
        if (toastLock) {
            return;
        }
        toastr.success(message, title);
    },
    info: (message: string, title?: string) => {
        if (toastLock) {
            return;
        }
        toastr.info(message, title);
    },
    warning: (message: string, title?: string) => {
        if (toastLock) {
            return;
        }
        toastr.warning(message, title);
    },
    error: (message: string, title?: string) => {
        if (toastLock) {
            return;
        }
        toastr.error(message, title);
    },
    admin: (message: string, title?: string) => {
        toastr.info(message, title);
    },
};
